import { useProfile } from 'context/profile';
import Episode from 'models/Episode';
import LocationEpisode from 'models/LocationEpisode';
import LocationEpisodeSummary from 'models/LocationEpisodeSummary';

type PermissionGuardProps = {
  permission: string | string[];
  strictMode?: boolean;
  fallback?: React.ReactNode;
  skipPermissionCheck?: boolean;
  children: React.ReactNode;
  locationEpisode?: LocationEpisode | LocationEpisodeSummary;
  episode?: Episode;
};

export default function PermissionGuard({
  permission,
  strictMode = true,
  fallback = <></>,
  skipPermissionCheck = false,
  children,
  locationEpisode,
  episode,
}: PermissionGuardProps) {
  const { profile } = useProfile();

  const permissions = Array.isArray(permission) ? permission : [permission];

  const isPermissionGranted = strictMode
    ? profile.hasAll(permissions, { episode, locationEpisode })
    : profile?.hasAny(permissions, { episode, locationEpisode });

  return skipPermissionCheck || isPermissionGranted ? children : fallback;
}
